import userService from '../../services/userService';
import { showNotification } from '../reducers/uiReducer';

// Types d'actions
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const FETCH_INVITATIONS_REQUEST = 'FETCH_INVITATIONS_REQUEST';
export const FETCH_INVITATIONS_SUCCESS = 'FETCH_INVITATIONS_SUCCESS';
export const FETCH_INVITATIONS_FAILURE = 'FETCH_INVITATIONS_FAILURE';

export const INVITE_USER_REQUEST = 'INVITE_USER_REQUEST';
export const INVITE_USER_SUCCESS = 'INVITE_USER_SUCCESS';
export const INVITE_USER_FAILURE = 'INVITE_USER_FAILURE';

export const DELETE_INVITATION_REQUEST = 'DELETE_INVITATION_REQUEST';
export const DELETE_INVITATION_SUCCESS = 'DELETE_INVITATION_SUCCESS';
export const DELETE_INVITATION_FAILURE = 'DELETE_INVITATION_FAILURE';

export const APPEND_USERS_REQUEST = 'APPEND_USERS_REQUEST';
export const APPEND_USERS_SUCCESS = 'APPEND_USERS_SUCCESS';
export const APPEND_USERS_FAILURE = 'APPEND_USERS_FAILURE';

export const CLEAR_USER_ERRORS = 'CLEAR_USER_ERRORS';

// Action pour récupérer tous les utilisateurs
export const getUsers = (params) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_USERS_REQUEST });
    
    const response = await userService.getUsers(params);
    
    // Transform structure of response to match component needs
    const formattedData = {
      items: response.users || [],
      pagination: response.pagination || {}
    };

    dispatch({
      type: FETCH_USERS_SUCCESS,
      payload: formattedData
    });
    
    return Promise.resolve(response);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la récupération des utilisateurs';
    
    dispatch({
      type: FETCH_USERS_FAILURE,
      payload: errorMessage
    });
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};

export const loadMoreUsers = (params) => async (dispatch) => {
  try {
    dispatch({ type: APPEND_USERS_REQUEST });

    const response = await userService.getUsers(params);

    const formattedData = {
      items: response.users || [],
      pagination: response.pagination || {}
    };

    dispatch({ type: APPEND_USERS_SUCCESS, payload: formattedData });
    return Promise.resolve(formattedData);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors du chargement';
    dispatch({ type: APPEND_USERS_FAILURE, payload: errorMessage });
    return Promise.reject(error);
  }
};

// Action pour récupérer un utilisateur par son ID
export const getUserById = (userId) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_USER_REQUEST });
    
    const response = await userService.getUserById(userId);
    
    // Assurez-vous que la réponse contient un utilisateur valide
    if (!response || !response.user) {
      throw new Error("Utilisateur non trouvé");
    }
    
    // Ajoutez une valeur par défaut pour company si elle n'existe pas
    const user = {
      ...response.user,
      company: response.user.company || null
    };
    
    dispatch({
      type: FETCH_USER_SUCCESS,
      payload: user
    });
    
    return Promise.resolve(response);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la récupération de l\'utilisateur';
    
    dispatch({
      type: FETCH_USER_FAILURE,
      payload: errorMessage
    });
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};

// Action pour créer un utilisateur
export const createUser = (userData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_USER_REQUEST });

    console.log("Creating user with data:", userData);
    
    const response = await userService.createUser(userData);
    
    dispatch({
      type: CREATE_USER_SUCCESS,
      payload: response.user
    });
    
    dispatch(showNotification({
      type: 'success',
      title: 'Succès',
      message: 'Utilisateur créé avec succès'
    }));
    
    return Promise.resolve(response);
  } catch (error) {
    // S'assurer que nous obtenons le message d'erreur correct de l'API
    const errorMessage =  error.response?.data?.message || 
                          error.response?.data?.errors?.[0]?.message ||
                          'Erreur lors de la création de l\'utilisateur';
    dispatch({
      type: CREATE_USER_FAILURE,
      payload: errorMessage
    });
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};

// Action pour mettre à jour un utilisateur
export const updateUser = (userId, userData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_USER_REQUEST });
    
    console.log("Updating user with data:", userData); // Log pour débogage

    const response = await userService.updateUser(userId, userData);
    
    dispatch({
      type: UPDATE_USER_SUCCESS,
      payload: response.user
    });
    
    dispatch(showNotification({
      type: 'success',
      title: 'Succès',
      message: 'Utilisateur mis à jour avec succès'
    }));
    
    return Promise.resolve(response);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la mise à jour de l\'utilisateur';
    
    dispatch({
      type: UPDATE_USER_FAILURE,
      payload: errorMessage
    });
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};

// Action pour supprimer un utilisateur
export const deleteUser = (userId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_USER_REQUEST });
    
    await userService.deleteUser(userId);
    
    dispatch({
      type: DELETE_USER_SUCCESS,
      payload: userId
    });
    
    dispatch(showNotification({
      type: 'success',
      title: 'Succès',
      message: 'Utilisateur supprimé avec succès'
    }));
    
    return Promise.resolve();
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la suppression de l\'utilisateur';
    
    dispatch({
      type: DELETE_USER_FAILURE,
      payload: errorMessage
    });
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};

// Action pour récupérer les invitations en attente
export const getPendingInvitations = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_INVITATIONS_REQUEST });
    
    const response = await userService.getPendingInvitations();
    
    dispatch({
      type: FETCH_INVITATIONS_SUCCESS,
      payload: response.invitations
    });
    
    return Promise.resolve(response);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la récupération des invitations';
    
    dispatch({
      type: FETCH_INVITATIONS_FAILURE,
      payload: errorMessage
    });
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};

// Action pour inviter un utilisateur
export const inviteUser = (invitationData) => async (dispatch) => {
  try {
    dispatch({ type: INVITE_USER_REQUEST });
    
    const response = await userService.inviteUser(invitationData);
    
    dispatch({
      type: INVITE_USER_SUCCESS,
      payload: response.invitation
    });
    
    dispatch(showNotification({
      type: 'success',
      title: 'Succès',
      message: 'Invitation envoyée avec succès'
    }));
    
    return Promise.resolve(response);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de l\'envoi de l\'invitation';
    
    dispatch({
      type: INVITE_USER_FAILURE,
      payload: errorMessage
    });
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};

// Action pour supprimer une invitation
export const deleteInvitation = (invitationId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_INVITATION_REQUEST });
    
    await userService.deleteInvitation(invitationId);
    
    dispatch({
      type: DELETE_INVITATION_SUCCESS,
      payload: invitationId
    });
    
    dispatch(showNotification({
      type: 'success',
      title: 'Succès',
      message: 'Invitation supprimée avec succès'
    }));
    
    return Promise.resolve();
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la suppression de l\'invitation';
    
    dispatch({
      type: DELETE_INVITATION_FAILURE,
      payload: errorMessage
    });
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};

// Action pour effacer les erreurs utilisateur
export const clearUserErrors = () => ({
  type: CLEAR_USER_ERRORS
});